export const SEARCH_NAME_TRUNCATE_LIMIT = 70;
